/* eslint-disable import/prefer-default-export */
export const ICON_ORIENTATION = { left: 'left', right: 'right'};
